// Generated by ReScript, PLEASE EDIT WITH CARE


var Layout = {};

var DTOHelpers = {
  Layout: Layout
};

var CardSize = {
  $$default: /* Md */4
};

var Link = {};

var CategoryCard = {};

function toString(sort) {
  switch (sort) {
    case /* Default */0 :
        return "default";
    case /* Newest */1 :
        return "newest";
    case /* HighestPrice */2 :
        return "highest_price";
    case /* LowestPrice */3 :
        return "lowest_price";
    case /* BestSellers */4 :
        return "best_sellers";
    case /* Featured */5 :
        return "featured";
    
  }
}

var ExternalConnectionSort = {
  toString: toString
};

var ExternalConnection = {};

var Page = {};

var empty = {
  id: "",
  title: "",
  description: undefined,
  showTitle: true,
  showDescription: true,
  visible: true,
  visibleInMenuBar: true,
  visibleInSectionList: true,
  visibleInParent: true,
  visibleInHeaderSlider: true,
  listPageActiveLayout: {
    TAG: /* SubCategoriesGrid */2,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  userSelectedLayout: {
    TAG: /* SubCategoriesGrid */2,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  forcedPLPLayout: {
    TAG: /* ProductGrid */3,
    _0: {
      columns: /* FourColumnGrid */3,
      gap: /* Equal */0,
      maxRows: undefined,
      maxWidth: undefined,
      padding: undefined,
      pattern: undefined
    }
  },
  tabbedSubCategories: undefined,
  card: {
    TAG: /* ImageLinkCard */0,
    _0: {
      link: {
        TAG: /* URL */0,
        _0: ""
      },
      imageUrl: "",
      size: /* Md */4,
      shape: /* Square */1
    }
  },
  categoryType: {
    TAG: /* Link */0,
    _0: {
      link: "",
      imageWidth: undefined,
      imageHeight: undefined
    }
  },
  socialNetworkSource: undefined,
  displayPriority: /* ChildrenFirst */0,
  expandVariantsInProductsListing: undefined,
  lastModifiedAt: undefined,
  sectionTheme: /* LegacyTheme */0,
  pageTheme: /* LegacyTheme */0,
  stickySection: false
};

export {
  DTOHelpers ,
  CardSize ,
  Link ,
  CategoryCard ,
  ExternalConnectionSort ,
  ExternalConnection ,
  empty ,
  Page ,
}
/* No side effect */
